import React, { HTMLAttributes } from "react";
import { inject, observer } from "mobx-react";
import { GlobalHotKeys } from "react-hotkeys";
/** Constants */
import HotKeyMap from "core/hotKeyMap/index";

@inject("hotkeyStore")
@observer
class UtilitySection extends React.Component {
  getHotkeys() {
    const { hotkeyStore } = this.props;
    return hotkeyStore.getHotkeys();
  }

  getHandlers() {
    const { hotkeyStore } = this.props;
    return hotkeyStore.getHandlers();
  }

  render() {
    const hotkeys = this.getHotkeys();
    const handlers = this.getHandlers();
    return (
      <React.Fragment>
        {/* 메세지 박스 대화상자 */}

        <GlobalHotKeys
          keyMap={hotkeys}
          handlers={handlers}
          //handlers={HotKeyMap.AppConfigGlobalHotKeys.handlers}
          allowChanges={true}
        />
      </React.Fragment>
    );
  }
}

export default UtilitySection;
